import { useState } from 'react';
import { ShieldAlert, CheckCircle2, ChevronLeft, ExternalLink } from 'lucide-react';

interface PdfReaderViewProps {
    url: string;
    title: string;
    onConfirm: (confirmed: boolean) => void;
}

export default function PdfReaderView({ url, title, onConfirm }: PdfReaderViewProps) {
    const [hasOpened, setHasOpened] = useState(false);

    const handleOpenPdf = () => {
        window.open(url, '_blank');
        setHasOpened(true);
    };

    return (
        <div className="fixed inset-0 z-[6000] bg-slate-950/95 backdrop-blur-xl flex items-center justify-center p-6 animate-in fade-in duration-300">
            <div className="max-w-md w-full bg-slate-900 border-2 border-cyan-500/20 rounded-[3rem] p-8 sm:p-10 shadow-[0_0_100px_rgba(6,182,212,0.15)] text-center space-y-8">
                <div className="w-20 h-20 bg-cyan-500/10 rounded-full flex items-center justify-center mx-auto border border-cyan-500/30">
                    <ShieldAlert className="text-cyan-400 w-10 h-10 animate-pulse" />
                </div>

                <div className="space-y-3">
                    <span className="px-3 py-1 bg-cyan-500/10 border border-cyan-500/20 text-cyan-400 rounded-full text-[9px] font-black uppercase tracking-widest">
                        Document de Sécurité
                    </span>
                    <h3 className="text-xl font-black text-white uppercase italic tracking-tighter leading-snug">{title}</h3>
                    <p className="text-slate-400 text-xs font-medium leading-relaxed px-2">
                        Pour valider votre prise de connaissance, veuillez ouvrir et consulter le document de sécurité ci-dessous.
                    </p>
                </div>

                <div className="flex flex-col gap-4">
                    <button
                        onClick={handleOpenPdf}
                        className="w-full py-4.5 bg-cyan-600 hover:bg-cyan-500 text-slate-950 rounded-2xl font-black uppercase tracking-widest text-xs active:scale-95 flex items-center justify-center gap-3 shadow-lg shadow-cyan-950/40 transition-all duration-200"
                    >
                        <ExternalLink size={18} />
                        LIRE LE DOCUMENT (PDF)
                    </button>

                    <div className="w-full h-[1px] bg-white/5 my-1" />

                    <button
                        onClick={() => onConfirm(true)}
                        disabled={!hasOpened}
                        className={`w-full py-4.5 rounded-2xl font-black uppercase tracking-widest text-xs transition-all duration-200 flex items-center justify-center gap-3
                            ${hasOpened 
                                ? 'bg-emerald-600 hover:bg-emerald-500 text-white active:scale-95 cursor-pointer shadow-lg shadow-emerald-950/40' 
                                : 'bg-slate-800 text-slate-600 cursor-not-allowed border border-white/5'}`}
                    >
                        <CheckCircle2 size={18} />
                        J'AI LU ET COMPRIS
                    </button>

                    <button
                        onClick={() => onConfirm(false)}
                        className="w-full py-3.5 bg-slate-850 hover:bg-slate-800 text-slate-400 rounded-2xl font-black uppercase tracking-widest text-[9px] border border-white/5 active:scale-95 flex items-center justify-center gap-3 transition-colors duration-200"
                    >
                        <ChevronLeft size={16} />
                        RETOUR
                    </button>
                </div>
            </div>
        </div>
    );
}
